export const SET_WARNINGMSG = 'SET_WARNINGMSG'
export const GET_WARNINGMSG = 'GET_WARNINGMSG'
export const RECEIVED_WARNINGMSG = 'RECEIVED_WARNINGMSG'



// WEBPACK FOOTER //
// ./src/store/modules/warningmsg/mutation-types.js